import React, { PropsWithChildren } from "react";
import styles from "./parts.module.css";
import classNames from "classnames";

type Props = {
  isFinished?: boolean;
  isUpdated?: boolean;
  isCancelled?: boolean;
  isSelected?: boolean;
  isRxBag?: boolean;
} & PropsWithChildren;

const BoxItemCard = ({
  isFinished,
  isUpdated,
  isCancelled,
  isSelected,
  isRxBag,
  children,
}: Props) => {
  const cardClassNames = classNames({
    [styles["box-item-card"]]: true,
    [styles["box-item-card--finished"]]: isFinished,
    [styles["box-item-card--updated"]]: isUpdated,
    [styles["box-item-card--cancelled"]]: isCancelled,
    [styles["box-item-card--selected"]]: isSelected,
    [styles["box-item-card--rx-bag"]]: isRxBag,

    // [styles["box-item-card--verified"]]: !isCancelled && isPickVerified,
  });
  return <article className={cardClassNames}>{children}</article>;
};

export default BoxItemCard;
